import { notification } from "antd";

export const successNotification = () =>
  notification["success"]({
    message: "Creación Exitosa",
    description:
      "Generando archivos!! En unos minutos vas a ver los resultados en la carpeta selccionada.",
    placement: "top",
    duration: 3,
  });

export const errorNotification = () =>
  notification["error"]({
    message: "Error",
    description: "Se ha producido un error, vuelva a intentar!",
    placement: "top",
    duration: 3,
  });

export const updatedNotification = () =>
  notification["success"]({
    message: "Modificación Exitosa",
    description: "La Lección fue modificada con éxito!",
    placement: "top",
    duration: 3,
  });

export const errorNotificationVideoQuiz = () =>
  notification["error"]({
    message: "Error",
    description: "Se debe cargar al menos un quiz y un video!",
    placement: "top",
    duration: 3,
  });
